export default "/images/ipaymer-hover-dark.svg?ae38a70c52bae39cb3d9010e92f4b384";